import {Controller} from '@hotwired/stimulus'
import {createElement} from 'react'
import {mountReactNode, unmountReactNode} from 'utils/reactRoots'

function resolveComponent(name) {
  const parts = name.split('.')
  const resolved = parts.reduce((obj, part) => {
    if (obj == null)
      return null
    return obj[part]
  }, window)

  if (resolved == null)
    return null

  return resolved.default || resolved
}

export default class extends Controller {
  static values = {
    component: String,
    props: {type: Object, default: {}},
  }

  connect() {
    this.mountComponent()
  }

  disconnect() {
    this.isMounted = false
    unmountReactNode(this.element)
  }

  propsValueChanged() {
    if (this.isMounted)
      this.mountComponent()
  }

  mountComponent() {
    this.isMounted = true
    const Component = resolveComponent(this.componentValue)

    if (!Component)
      return

    mountReactNode(createElement(Component, this.propsValue), this.element)
  }
}
